import axios from 'axios'
const log = require('bows')('WordpressCim40', '[FE]')

const fetchData = data =>
  new Promise(resolve => {
    const popupData = {
      ...data,
      title: '',
      description: '',
      buttons: [],
      customAttributes: [],
      media: [],
      externalMedia: []
    }
    const formatDate = function (ISODate) {
      const date = new Date(ISODate)

      return `${date.getDay()} ${date.toLocaleString('it-IT', { month: 'long' }).toUpperCase()} ${date.getFullYear()}`
    }

    const courseCategories = [
      { id: 1, tag: 'TagD03', name: 'WCM' },
      { id: 2, tag: 'TagD04', name: 'Additive Manufacturing' },
      { id: 3, tag: 'TagD02', name: 'Data science' },
      { id: 4, tag: 'TagD01', name: 'Predictive Maintenance' },
      { id: 5, tag: 'TagD05', name: 'Metodi e strumenti per la trasformazione digitale' },
      { id: 6, tag: 'TagD06', name: 'Cyber Security' }
    ]

    if (data.dataUrl) {
      axios
        .get(data.dataUrl)
        .then(response => {
          const responseData = response.data
          //log(responseData)

          if (responseData) {
            // opens an external link
            if (responseData.type === 'external') {
              popupData.action = 'external'
              popupData.url = responseData.external_url || ''
            }
            // opens a popup
            else {
              popupData.title = responseData.title || ''
              popupData.description = responseData.description || ''

              // eventually show a list of items
              if (responseData.type === 'list' && responseData.items.length > 0) {
                const isDateRequired = ['comunicato_stampa', 'event', 'news', 'press'].includes(
                  responseData.list_type
                )

                const items =
                  responseData.list_type === 'course'
                    ? responseData.items.filter(i =>
                        i.percorso
                          ? i.percorso.find(
                              p =>
                                p.id ===
                                courseCategories.find(
                                  c => c.tag === data.dataUrl.substring(data.dataUrl.lastIndexOf('/') + 1)
                                ).id
                            )
                          : false
                      )
                    : responseData.items

                const htmlTable = `<br><table width: 100%; style="width: 100%;"><tbody>${items
                  .map(i => {
                    return `<tr style="border-bottom: 1px solid #999999;">${
                      isDateRequired ? `<td style="padding: 10px 10px; width:30%;">${formatDate(i.date)}</td>` : ''
                    }<td style="padding: 10px 10px;"><a href="${responseData.list_type === 'press' ? i.file.guid : i.link}" target="_blank">${
                      i.title.rendered
                    }</a></td></tr>`
                  })
                  .join('')}</tbody></table>`
                popupData.description += htmlTable
              }

              popupData.buttons =
                responseData.buttons ? responseData.buttons.map(b => {
                  const commonProps = { type: b.type, text: b.text, style: 'default' }
                  return b.type === 'mailto'
                    ? { ...commonProps, to: [b.to], cc: [b.cc], bcc: [b.bcc], subject: b.subject }
                    : { ...commonProps, content: b.content }
                }) : []
              popupData.externalMedia =
                responseData.media ? responseData.media.map(m => {
                  return { type: m.type, url: `${m.type === 'image' ? m.image_url : m.video_url}` }
                }) : []
            }
            resolve(popupData)
          } else {
            resolve(false)
            throw new Error('No data returned for clicked tag')
          }
        })
        .catch(e => log(e))
    } else {
      resolve(popupData)
    }
  })

//get images/videos to show inside the 3D environment as hotspots
const fetchMedia = data =>
  new Promise(resolve => {
    let mediaHotspots = data.mediaHotspots
    if (data.dataUrl) {
      axios.get(data.dataUrl).then(response => {
        const hotspots = response.data
        //log(hotspots)

        mediaHotspots = mediaHotspots.map(m => {
          const match = hotspots.find(h => {
            if (h.hotspot) {
              return h.hotspot.replace('Hotspot', 'Tag') === m.actionContent
            } 
          } )
          if (match && match.type === m.type) {
            return { ...m, src: match.media_url.replaceAll('&', '&amp;'), isExternal: true }
          }
          return m
        })
        resolve(mediaHotspots)
      })
    } else {
      resolve(mediaHotspots)
    }
  })

export { fetchData, fetchMedia }
